import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import { ImageAssetFieldsFragmentDoc } from './imageAssetFields.generated';
export type GameFieldsFragment = { __typename?: 'game', game_id?: string | null, id: string, translations?: Array<{ __typename?: 'game_translations', display_name?: string | null, slug?: string | null } | null> | null, game_image?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_wide?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, tags?: Array<{ __typename?: 'game_game_tags', game_tags_id?: { __typename?: 'game_tags', translations?: Array<{ __typename?: 'game_tags_translations', name?: string | null } | null> | null } | null } | null> | null };

export const GameFieldsFragmentDoc = gql`
    fragment GameFields on game {
  game_id
  id
  translations(
    filter: {languages_language_code: {language_code: {_eq: $language}}}
  ) {
    display_name
    slug
  }
  game_image(filter: null) {
    ...ImageAssetFields
  }
  game_image_wide(filter: null) {
    ...ImageAssetFields
  }
  game_image_box(filter: null) {
    ...ImageAssetFields
  }
  game_image_tall(filter: null) {
    ...ImageAssetFields
  }
  tags {
    game_tags_id(filter: null) {
      translations(
        filter: {languages_language_code: {language_code: {_eq: $language}}}
      ) {
        name
      }
    }
  }
}
    ${ImageAssetFieldsFragmentDoc}`;